import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppConfirmation from './AppConfirmation';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Check if this is the confirmation app (subdomain)
const isConfirmationApp = process.env.REACT_APP_ENTRY === 'confirmation' || 
                         window.location.hostname === 'app.localhost' ||
                         window.location.hostname === 'app.bookmyshot.com';

root.render(
  <React.StrictMode>
    {isConfirmationApp ? <AppConfirmation /> : <App />}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
